import { Button } from "@/components/ui/button";

interface Props {
  isLoading: boolean;
  onRetry: () => void;
}

export const ReportStatus = ({ isLoading, onRetry }: Props) =>
  isLoading ? (
    <p className="p-10 text-center text-sm text-gray-500">Loading report…</p>
  ) : (
    <div className="p-10 text-center">
      <p className="text-sm text-red-700">The report could not be loaded.</p>
      <Button variant="outline" size="sm" className="mt-3" onClick={onRetry}>
        Try again
      </Button>
    </div>
  );
